import React, { useRef } from 'react';
import type { SVGProps } from 'react';

interface TopicIconSvgProps extends SVGProps<SVGSVGElement> {}

let identityClipCounter = 0;

export const IdentityIcon: React.FC<TopicIconSvgProps> = (props) => {
  const clipIdRef = useRef<string | null>(null);
  if (clipIdRef.current === null) {
    clipIdRef.current = `identity-clip-${++identityClipCounter}`;
  }
  const clipId = clipIdRef.current;
  return (
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M5.13226 16.8831C6.43303 21.7377 11.4224 24.6183 16.277 23.3175C21.1315 22.0167 24.0121 17.0273 22.7114 12.1728C21.6934 8.37361 18.4162 5.78338 14.7125 5.46023L14.7125 3.55341C14.7674 3.55736 14.8222 3.56172 14.877 3.5665C19.3543 3.95698 23.3164 7.0883 24.547 11.6809C26.1194 17.5491 22.6369 23.5808 16.7688 25.1531C10.9007 26.7255 4.86899 23.2431 3.29663 17.375C3.11258 16.6881 2.99778 15.9989 2.94797 15.315L4.85476 15.315C4.90061 15.8361 4.9922 16.3604 5.13226 16.8831Z"
          fill="currentColor"
        />
        <path
          d="M4.80134 10.2806L5.66231 10.6828C5.21688 11.6367 4.93548 12.6687 4.84215 13.7344L2.92402 13.7346C3.03705 12.4441 3.40377 11.0308 3.94156 9.87908L4.80134 10.2806ZM8.68911 7.07125C7.81284 7.68494 7.05986 8.44461 6.45642 9.30734L4.90002 8.21898C5.62852 7.17739 6.5375 6.25746 7.5986 5.51431L8.68911 7.07125ZM11.0632 3.90254C11.6831 3.73642 12.3052 3.63023 12.9234 3.57391C13.0766 3.55996 13.1099 3.55671 13.1195 3.55587L13.1195 5.46052C12.6009 5.50649 12.078 5.59806 11.555 5.73818C11.0321 5.87829 10.5335 6.06045 10.0613 6.27995L9.26088 4.56037C9.83245 4.29458 10.4333 4.0713 11.0632 3.90254Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
